﻿var klaviyoPopup = {};

klaviyoPopup = {

  init: function (target) {
    console.log('init klaviyo popup', target)
    const banners = target.querySelectorAll('.banner')

    if (banners) {
      banners.forEach(banner => {
        banner.classList.remove('banner')
        banner.classList.add('klaviyo-banner')
        if (banner.classList.contains('banner--has-content')) {
          banner.classList.add('klaviyo-banner--has-content')
          banner.classList.remove('banner--has-content')
        }

        const bannerContent = banner.querySelectorAll('.banner__content')
        if (bannerContent) {
          bannerContent.forEach(bc => {
            bc.classList.add('klaviyo-banner__content')
            bc.classList.remove('banner__content')
          })
        }
      })
    }
  },
};

klaviyoPopup.initialize = function (targets) {
  console.log('popoup initalize', targets)
  targets.forEach(target => {
    klaviyoPopup.init(target);
  })
};

module.exports = klaviyoPopup;
